import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { channelVideoInitialValues } from 'components/organisms/forms/channel-video/ChannelVideoForm';
import { useCustomParamId, useParamId } from 'hooks/useParamId';
import { PiNavigationArrow } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetChannelVideo } from 'services/channel';

const ChannelVideo = () => {
  const videoId = useCustomParamId('videoId', 'channel');

  const getVideo = useGetChannelVideo(videoId);

  const navigateToYtVideo = () => {
    const targetPath = `https://www.youtube.com/watch?v=${getVideo.data?.externalVideoId}`;
    window.open(targetPath, '_blank');
  };

  return (
    <Form.ChannelVideo
      status={{ isLoading: getVideo.isLoading, displayMode: true }}
      i18nextPrefix='channel'
      initialValues={
        getVideo.data
          ? { ...channelVideoInitialValues, ...getVideo.data }
          : channelVideoInitialValues
      }
      onSubmit={() => {}}
      tittle={getVideo.data?.videoTitle ?? '-'}
      topbarContent={
        <Button
          onlyIcon
          disabled={!getVideo.data}
          isClear
          onClick={() => navigateToYtVideo()}>
          <Button.Icon icon={<PiNavigationArrow transform='scale(-1,1)' />} />
        </Button>
      }
    />
  );
};

export default ChannelVideo;
